import { render, staticRenderFns } from "./AttributeSets.vue?vue&type=template&id=126b0502&scoped=true&"
import script from "./AttributeSets.vue?vue&type=script&lang=js&"
export * from "./AttributeSets.vue?vue&type=script&lang=js&"
import style0 from "./AttributeSets.vue?vue&type=style&index=0&id=126b0502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b0502",
  null
  
)

export default component.exports